import assetPath from '/app/packages/lebenslauf/components/src/assets/open-sans-light.woff';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')